import { avatarSrc, onAvatarError } from "../../utils/avatar";
import React, { useState } from "react";

export default function User({ user, avatar }) {
  return (
    <div className="mt-2 d-flex align-items-center">
      <img className="user-avatar" src={avatarSrc(avatar)} onError={onAvatarError} />
      {/* <Avatar className="user-avatar" name={user} round={true} size="50px" /> */}
      <div>{user}</div>
    </div>
  );
}
